module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"only_within_same_day":"Only within the same day","one_day_or_more":"One day or more","customers_can_schedule":"Customers can schedule their orders","in_advance":"in advance"},"id":{"only_within_same_day":"Hanya pada hari yang sama","one_day_or_more":"Satu hari atau lebih ","customers_can_schedule":"Pelanggan dapat menjadwalkan pesanan mereka","in_advance":"sebelumnya"}}')
  delete Component.options._Ctor
}
